<app-system-new-modal
  identificator="nameDocumentModal"
  title="Nombre del documento"
  buttonName="Crear"
  [disabledButton]="nameDocument === '' ? true : false"
  [action]="createDocument.bind(this)"
  [closeModal]="closeModal.bind(this)"
>
  <ng-container content>
    <input
      type="text"
      class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-system-400 focus:border-system-400 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-system-primary dark:focus:border-system-primary"
      placeholder="Nombre del documento"
      [(ngModel)]="nameDocument"
    />
  </ng-container>
</app-system-new-modal>
<app-create-order
  [closeModal]="closeModalOrder.bind(this)"
  [action]="createOrder.bind(this)"
  [showButton]="showWidgetCalendar"
  [disabledButton]="sendingData"
>
  <ng-container content>
    <div class="flex flex-col gap-4" *ngIf="!showWidgetCalendar">
      <p class="text-gray-500 text-base font-normal">
        {{ 'DASHBOARD.ORDER.DESCRIPTION' | translate }}
        <span class="font-semibold">{{ 'DASHBOARD.ORDER.DESCRIPTION BOLD' | translate }}</span>
      </p>
      <div>
        <app-input-set
          forLabel="orderName"
          [label]="'DASHBOARD.ORDER.LABEL NAME DOCUMENT' | translate"
          [control]="createOrderForm.get('orderName')"
          [isRequired]="true"
          [type]="inputType.TEXT"
          [submitting]="loading"
          placeholder="{{ 'DASHBOARD.ORDER.PLACEHOLDER DOCUMENT' | translate }}"
        ></app-input-set>
        <small class="helper-text text-sm text-gray-500">
          {{ 'DASHBOARD.ORDER.HELPER TEXT DOCUMENT' | translate }}
        </small>
      </div>
      <div>
        <app-input-set
          forLabel="files"
          [label]="'DASHBOARD.ORDER.LABEL FILE DOCUMENT' | translate"
          [control]="createOrderForm.get('files')"
          [type]="inputType.FILE"
          [isMultiple]="true"
          [isRequired]="true"
          [submitting]="loading"
          (sendFile)="changeDocumentOrder($event)"
        ></app-input-set>
        <small class="helper-text text-sm text-gray-500" *ngIf="filesSelectedList.length <= 0">
          {{ 'DASHBOARD.ORDER.HELPER TEXT FILE DOCUMENT' | translate }}
        </small>
        <div class="files-list flex flex-col gap-1 my-2 px-4 w-full" *ngIf="filesSelectedList.length > 0">
          <div
            class="files-list-item flex items-center justify-between border-b border-gray-200 pb-1"
            *ngFor="let item of filesSelectedList; let i = index"
          >
            <small class="files-list-item__name">{{ item.name }}</small>
            <app-system-icon
              iconName="close"
              iconType="outline"
              [iconSize]="14"
              class="text-red-500 cursor-pointer"
              (click)="removeFileFromList(i)"
            ></app-system-icon>
          </div>
        </div>
      </div>
      <div>
        <app-input-set
          forLabel="description"
          [label]="'DASHBOARD.ORDER.LABEL COMMENTS' | translate"
          [control]="createOrderForm.get('description')"
          [type]="inputType.TEXTAREA"
          [isRequired]="true"
          placeholder="{{ 'DASHBOARD.ORDER.PLACEHOLDER COMMENTS' | translate }}"
          [submitting]="loading"
        ></app-input-set>
        <small class="helper-text text-sm text-gray-500">
          {{ 'DASHBOARD.ORDER.HELPER TEXT COMMENTS' | translate }}
        </small>
      </div>
    </div>
    <app-calendly *ngIf="showWidgetCalendar" class="w-full h-[600px]"></app-calendly>
  </ng-container>
</app-create-order>

<aside
  id="cta-button-sidebar"
  class="fixed top-0 left-0 w-64 z-20 h-screen transition-transform -translate-x-full sm:translate-x-0"
  aria-label="Sidebar"
>
  <div class="h-full overflow-y-auto bg-white dark:bg-gray-800 flex flex-col">
    <div class="px-8 py-4 border-gray-200 border-b container-logo">
      <app-system-logo></app-system-logo>
    </div>
    <div class="px-3 pb-4 pt-1 border-r border-gray-200 flex-grow">
      <div class="ps-2.5 mb-5">
        <button
          (click)="initializeOrderModal()"
          systemButton
          class="w-full flex justify-center gap-1 items-center mt-3"
          buttonType="primary"
        >
          {{ 'DASHBOARD.HOME SPACE.NEW ORDER' | translate }}
        </button>
        <button
          (click)="openModal()"
          systemButton
          class="w-full flex justify-center gap-1 items-center mt-3"
          buttonType="secondary"
        >
          {{ 'DASHBOARD.HOME SPACE.NEW AUTOMATION' | translate }}
        </button>
      </div>
      <ul class="space-y-2 font-medium">
        <ng-container *ngFor="let item of menu">
          <li *ngIf="!item.children">
            <a
              [routerLink]="item.route"
              routerLinkActive="bg-gray-100"
              #rla="routerLinkActive"
              class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
            >
              <app-system-icon
                [ngClass]="{ 'text-system-500': rla.isActive, 'text-system-300': !rla.isActive }"
                [iconName]="item.icon"
              ></app-system-icon>
              <span class="ms-3">{{ 'DASHBOARD.' + item.text | translate }}</span>
            </a>
          </li>
          <li *ngIf="item.children">
            <div
              class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group cursor-pointer"
              (click)="item.expanded = !item.expanded"
            >
              <app-system-icon
                [iconName]="item.icon"
                [ngClass]="{ 'text-system-500': item.expanded, 'text-system-300': !item.expanded }"
              ></app-system-icon>
              <span class="ms-3 flex-1">{{ 'DASHBOARD.' + item.text | translate }}</span>
              <app-system-icon
                iconName="chevron-down"
                class="transition-transform"
                [ngClass]="{ 'rotate-180': item.expanded }"
              ></app-system-icon>
            </div>
            <ul *ngIf="item.expanded" class="pl-8 mt-1 space-y-1">
              <li *ngFor="let sub of item.children">
                <a
                  [routerLink]="sub.route"
                  routerLinkActive="bg-gray-100"
                  #rlaSub="routerLinkActive"
                  class="flex items-center p-2 text-sm text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                >
                  <app-system-icon
                    [ngClass]="{ 'text-system-500': rlaSub.isActive, 'text-system-300': !rlaSub.isActive }"
                    [iconName]="sub.icon"
                  ></app-system-icon>
                  <span class="ms-3">{{ 'DASHBOARD.' + sub.text | translate }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ng-container>
      </ul>
      <ul class="pt-4 mt-4 space-y-2 font-medium border-t border-gray-200 dark:border-gray-700">
        <li>
          <a
            href="#"
            class="flex items-center p-2 text-gray-900 transition duration-75 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white group"
          >
            <app-system-icon iconName="life-saver" [iconType]="'solid'" class="text-system-300"></app-system-icon>
            <span class="ms-3">{{ 'DASHBOARD.HELP' | translate }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</aside>

<app-toast
  [message]="toastMessage"
  [type]="typeToastMessage"
  [showToast]="showToastMessage"
  (showToastChange)="showToastMessage = $event"
  [duration]="durationToastMessage"
></app-toast>
